// extracted by mini-css-extract-plugin
module.exports = {"booksList":"Book_booksList__GSsot"};